import api from './api';

export interface ReferralResponse {
  referral_code: string;
  referral_link: string;
}

export interface ReferralStats {
  total_referrals: number;
  successful_referrals: number;
  pending_referrals: number;
  total_credits_earned: number;
  credits_this_month: number;
}

export interface FeedbackSubmission {
  usage_frequency: string;
  primary_use_case: string;
  overall_satisfaction: number;
  ease_of_use: number;
  output_quality: number;
  important_features: string[];
  new_features: string;
  pain_points: string;
  nps_score: number;
  upgrade_motivation: string;
  additional_comments: string;
}

export interface FeedbackResponse {
  success: boolean;
  message: string;
  credits_awarded: number;
  feedback_id: string;
}

export const creditsService = {
  // Referral endpoints
  async getReferralLink(): Promise<ReferralResponse> {
    const response = await api.get('/referrals/referral-link');
    return response.data;
  },

  async getReferralStats(): Promise<ReferralStats> {
    const response = await api.get('/referrals/referral-stats');
    return response.data;
  },

  // Feedback endpoints
  async submitFeedback(feedbackData: FeedbackSubmission): Promise<FeedbackResponse> {
    const response = await api.post('/feedback/submit', feedbackData);
    return response.data;
  },

  async checkFeedbackEligibility(): Promise<{ eligible: boolean; message: string }> {
    const response = await api.get('/feedback/eligibility');
    return response.data;
  }
};